import React from 'react'
import CounsellorCardData from './CounsellorCardData'
import CounsellorCardAnalytics from './CounsellorCardAnalytics'

function CounsellorCardWidget({ setSelectedOptions, selectedOptions }) {
    return (
        <div className="min-w-[408px] max-w-[408px] h-full bg-white rounded-[24px] ">
            <CounsellorCardData selectedOptions={selectedOptions} />
            <CounsellorCardAnalytics setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} />
        </div>
    )
}

export default CounsellorCardWidget
